"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelConnectionSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ChannelConnectionSchema = __1.BaseSchema.extend({
    authFlowState: __1.ShortStringSchema,
    authFlowRedirectUri: __1.LongStringSchema.url().optional(),
    authFlowChannelStoreUri: __1.LongStringSchema.url().optional(),
    credentials: zod_1.z.record(zod_1.z.any({})).optional(),
    connectedAt: zod_1.z.coerce.date().optional(),
    expiresAt: zod_1.z.coerce.date().optional(),
    authorizationExpiresAt: zod_1.z.coerce.date().optional(),
    refreshTokenExpiresAt: zod_1.z.coerce.date().optional(),
    channelStoreId: __1.ShortStringSchema,
    status: zod_1.z.nativeEnum(__1.ChannelConnectionStatus),
    store: __1.StoreSchema,
    channel: __1.ChannelSchema,
    offersState: zod_1.z.nativeEnum(__1.ChannelConnectionOffersState).optional(),
});
//# sourceMappingURL=index.js.map